import React from "react"
import { useTranslation } from "react-i18next"

import { useTheme } from "hooks"
import { isFrenchLanguage } from "utils/i18n"
import {
	BC_CGU_LINK,
	BC_LEGAL_NOTICE,
	BC_PRIVACY_POLICY,
	MC_CGU_LINK,
	MC_LEGAL_NOTICE,
	MC_PRIVACY_POLICY,
	MFC_CGU_LINK,
	MFC_LEGAL_NOTICE,
	MFC_PRIVACY_POLICY,
} from "utils/constants"

const documentItem = (link: string, text: string) => {
	return (
		<div className="flex py-2 px-5 mb-3">
			<a href={link} target="_blank" rel="noopener noreferrer" className="text-xs">
				{text}
			</a>
		</div>
	)
}

export const LegalDocuments: React.FC = () => {
	const { currentTheme } = useTheme()
	const { t } = useTranslation()

	const languageExtension = isFrenchLanguage() ? "FR" : "EN"

	return (
		<div className="mt-4 mb-10">
			{currentTheme.id === "bicycode" && (
				<div className="mb-2 py-2.5">
					{documentItem(BC_LEGAL_NOTICE[languageExtension], t("menu.legal_notice"))}
					{documentItem(BC_CGU_LINK[languageExtension], t("menu.terms_of_service"))}
					{documentItem(BC_PRIVACY_POLICY[languageExtension], t("menu.confidentiality"))}
				</div>
			)}

			{currentTheme.id === "mfc" && (
				<div className="mb-2 py-2.5">
					{documentItem(MFC_LEGAL_NOTICE[languageExtension], t("menu.legal_notice"))}
					{documentItem(MFC_CGU_LINK[languageExtension], t("menu.terms_of_service"))}
					{documentItem(MFC_PRIVACY_POLICY[languageExtension], t("menu.confidentiality"))}
				</div>
			)}

			{currentTheme.id === "mc" && (
				<div className="py-2.5">
					{documentItem(MC_LEGAL_NOTICE[languageExtension], t("menu.legal_notice"))}
					{documentItem(MC_CGU_LINK[languageExtension], t("menu.terms_of_service"))}
					{documentItem(MC_PRIVACY_POLICY[languageExtension], t("menu.confidentiality"))}
				</div>
			)}
		</div>
	)
}
